import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Edit from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import { tableTdIconStyles } from "../../../config/styles";
import { dataForEventTypesTable } from "../../../services/entities/eventTypes";
import { StyledTableCell, StyledTableCellHead, StyledTableRow } from '../../atoms/table/tableStyles';
import Strip from '../../atoms/Wrappers/Strip';
import { invokeGetService } from "../../../store/global/actions";
import { getInnerScreenRender, getReRender} from '../../../store/global/selectors';
import CircularProgress from '@material-ui/core/CircularProgress';



export default function ListEventTypes({ element, setAction, }) {


    const dispatch = useDispatch()
    // const eventTypesInfo = dataForEventTypesTable({ messages: messageArray, fields });
    const [eventTypesInfo, setEventTypesInfo] = useState([]);
    const [loading, setLoading] = useState(false);
    const innerScreenRender = useSelector(getInnerScreenRender);
    const reRender = useSelector(getReRender);
    

    useEffect(() => {
        setLoading(true);
        dispatch(invokeGetService('getBlueprintConstructs', {}))
            .then((response) => {
                if (response.status) {

                    let messageArray = response?.data?.messages;
                    let fields = response?.data?.fields;
                    setEventTypesInfo(dataForEventTypesTable({ messages: messageArray, fields }))

                }
                setLoading(false);

            })

    }, [innerScreenRender])


    return (
        <>
            {/* {eventTypesInfo.length === 0 && <NoEventTypeAlert />} */}

            <TableContainer component={Paper} style={{ marginTop: 20, borderRadius: 0, boxShadow: 'none' }} >
                <Table aria-label="customized table" id="eventtypes_table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead align='left'> Name </StyledTableCellHead>
                            <StyledTableCellHead align='left' style={{ width: 500 }}> Fields </StyledTableCellHead>
                            <StyledTableCellHead align='right'> Actions </StyledTableCellHead>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {loading ?
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                    Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                </StyledTableCell>
                            </StyledTableRow>
                            : eventTypesInfo.length < 1 ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                        No messages available.
                                    </StyledTableCell>
                                </StyledTableRow>
                                :
                                eventTypesInfo.map((message, index) => (
                                    <StyledTableRow key={message.id}>

                                        <StyledTableCell align={'left'} component="td" >
                                            {message.name}
                                        </StyledTableCell>

                                        <StyledTableCell align={'left'} component="td" >
                                            {message.fields.map(field => field).join(', ')}
                                        </StyledTableCell>

                                        <StyledTableCell align="right" >

                                            <Tooltip title="Edit event type">
                                                <IconButton aria-label="more" size="small" aria-haspopup="true" onClick={() => setAction({ action: 'edit_event_type', id: message._id, item: message })}>
                                                    <Edit style={tableTdIconStyles} color="primary" />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title="Delete event type">
                                                <IconButton aria-label="more" size="small" aria-haspopup="true" onClick={() => setAction({ action: 'delete_event_type', id: message._id, item: message })}>
                                                    <DeleteIcon style={tableTdIconStyles} color="error" />
                                                </IconButton>
                                            </Tooltip>

                                        </StyledTableCell>

                                    </StyledTableRow>
                                ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
